import { DAYJS_LOCALES } from '@/lib/utils';
import dayjs from 'dayjs';

export const useMonth = (locale: string, date: Date | string) => {
  const month = dayjs(new Date(date)).locale(DAYJS_LOCALES[locale]).format('MMMM');
  return month;
};
